
import React from 'react';
import AnimatedSection from './AnimatedSection.tsx';

const HeroSection: React.FC = () => {
  return (
    <AnimatedSection className="text-center flex flex-col items-center">
      <p className="text-lg md:text-xl text-neon-cyan neon-text-cyan tracking-widest">
        SYSTEM UPGRADE COMPLETE
      </p>
      <h2 className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-black my-4 text-neon-purple neon-text-purple uppercase">
        Level 14 Unlocked
      </h2>
      <p className="text-md md:text-lg text-gray-300 tracking-wider">
        Player: Grisha. Status: <span className="text-neon-cyan font-bold">Legendary</span>
      </p>
    </AnimatedSection>
  );
};

export default HeroSection;
